import Skeleton from 'react-loading-skeleton';
import getColumnClass from '../../utils/getColumnClass';

const CardSkeleton = ({ cards, gridSize, windowWidth }) => {
  return Array(cards)
    .fill(0)
    .map((index) => (
      <section
        key={index}
        className={`card_container p-2 ${getColumnClass(
          gridSize,
          windowWidth
        )}`}
      >
        <div className="product_card">
          <Skeleton height={210} />

          <div className="product_details">
            <h5 className="w-100 product_title">
              <Skeleton count={6} />
            </h5>
            <Skeleton count={1} />
          </div>
        </div>
      </section>
    ));
};

export default CardSkeleton;
